"use client";

import RouteError from "@/client/components/route-error";

export default RouteError;
